import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(public toastCtrl: ToastController) {}

  public async presentToast(
    text,
    color = 'dark',
    duration = 2000,
    location: any = 'top'
  ) {
    const toast = await this.toastCtrl.create({
      message: text,
      duration: duration,
      position: location,
      color: color,
    });
    await toast.present();
  }

  public async presentDangerToast(text) {
    const toast = await this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'bottom',
      color: 'danger',
      cssClass: 'text-center',
    });
    await toast.present();
  }
}
